import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {TaskModuleMediaData} from '../../../../../micromate-learn-lib/src/lib/types/TaskModuleMediaData';

@Component({
    selector: 'mm-profile-media-presentation',
    templateUrl: './profile-media-presentation.component.html',
    styleUrls: ['./profile-media-presentation.component.scss'],
    standalone: false
})
export class ProfileMediaPresentationComponent implements OnInit {
    public mediaData: TaskModuleMediaData | undefined;

    constructor(private activatedRoute: ActivatedRoute,
                private titleService: Title,
                private changeDetectorRef: ChangeDetectorRef) {
        this.titleService.setTitle('Micromate Profile');
    }

    public ngOnInit(): void {
        this.activatedRoute.queryParamMap.subscribe(params => {
            const data = params.get('data');
            // eslint-disable-next-line no-null/no-null
            if (data !== null) {
                this.mediaData = JSON.parse(data) as TaskModuleMediaData;
                this.changeDetectorRef.markForCheck();
            }
        });
    }

}
